<div>
    <mat-accordion class="faqs-accordion">
        <mat-expansion-panel 
            *ngFor="let invest of clientEquity; let i = index"            
            (opened)="getProductClient(invest.id)"
        >
            <mat-expansion-panel-header
                *ngIf="invest.value > 0"
            >
                <mat-panel-title 
                    fxLayout="row" 
                    fxLayoutAlign="start center"
                >
                    <mat-icon class="mr-12 s-20 secondary-text">add_circle</mat-icon>
                    <span style="text-transform: uppercase">{{invest.name}}</span>
                </mat-panel-title>
                <mat-panel-description>
                    R$  {{invest.value | number : '1.2-2'}}
                </mat-panel-description>
            </mat-expansion-panel-header>

            <ng-template *ngIf="invest.value > 0" matExpansionPanelContent>
                <ngx-datatable 
                    #tableAtivo
                    class='material'                             
                    [loadingIndicator]="loadingList"
                    [columns]="columns" 
                    [columnMode]="'force'" 
                    [headerHeight]="50"
                    [footerHeight]="50"
                    [rowHeight]="'auto'"
                    [rows]='rows'
                >       
                
                    <ngx-datatable-column 
                        name="Mercado" 
                        prop="mercado" 
                        [sortable]="false"
                        *ngIf="invest.id == 1"
                    >
                        <ng-template 
                            let-rowIndex="rowIndex" 
                            let-row="row" 
                            ngx-datatable-cell-template
                        >
                            {{row.mercado}}
                        </ng-template>
                    </ngx-datatable-column>  

                    <ngx-datatable-column 
                        name="Produto" 
                        prop="ativo" 
                        [sortable]="false"
                        *ngIf="invest.id == 5 || invest.id == 2"
                    >
                        <ng-template 
                            let-rowIndex="rowIndex" 
                            let-row="row" 
                            ngx-datatable-cell-template
                        >
                            {{row.produto}}
                        </ng-template>
                    </ngx-datatable-column>
    
                    <ngx-datatable-column 
                        name="Ativo" 
                        prop="ativo" 
                        [sortable]="false"
                        *ngIf="invest.id != 5"
                    >
                        <ng-template 
                            let-rowIndex="rowIndex" 
                            let-row="row" 
                            ngx-datatable-cell-template
                        >
                            {{row.ativo == null ? row.produto : row.ativo }}
                        </ng-template>
                    </ngx-datatable-column>
                
                    <ngx-datatable-column 
                        name="Quantidade" 
                        prop="ativo" 
                        [sortable]="true"
                        *ngIf="invest.id != 10"
                    >
                        <ng-template  
                            let-rowIndex="rowIndex" 
                            let-row="row" 
                            ngx-datatable-cell-template
                        >
                            <span>
                                <b>{{ row.quantidade | number : '1.0-0'}}</b>
                            </span>   
                        </ng-template>
                    </ngx-datatable-column>
                    
                    <ngx-datatable-column 
                        name="Valor Liquido" 
                        prop="valor_liquido" 
                        [sortable]="true"
                    >
                        <ng-template 
                            let-rowIndex="rowIndex" 
                            let-row="row" 
                            ngx-datatable-cell-template
                        >
                            <span >
                                R$ {{ row.valor_liquido | number : '1.2-2' }}
                            </span>
                        </ng-template>
                    </ngx-datatable-column>                    
                
                </ngx-datatable>
            </ng-template>
            
        </mat-expansion-panel>
    </mat-accordion>
</div>